















































import { Vue, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import PayoutData from '@/data/PayoutData';

@Component({
  components: {
    Table,
  },
})
export default class UserOnlineView extends Vue {
  TableHead = PayoutData.TableHead;
}
